var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "flex flex-col lg:flex-row",
      style: { maxWidth: "fit-content" },
    },
    [
      _c(
        "div",
        { staticClass: "flex gap-2" },
        [
          _vm.text
            ? _c(
                "span",
                { staticClass: "text-base", style: { minWidth: "400px" } },
                [_vm._v(_vm._s(_vm.text))]
              )
            : _vm._e(),
          this.$vuetify.breakpoint.smAndDown
            ? _c("v-fade-transition", [
                _vm.icon && !_vm.isTimeout
                  ? _c(
                      "div",
                      [
                        _vm.loading
                          ? _c("v-progress-circular", {
                              attrs: {
                                size: "16",
                                width: "2",
                                indeterminate: "",
                              },
                            })
                          : _c("v-img", {
                              attrs: {
                                src: _vm.icon,
                                height: "16",
                                eager: "",
                                contain: "",
                              },
                            }),
                      ],
                      1
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "flex gap-2 flex-col lg:flex-row" },
        [
          !this.$vuetify.breakpoint.smAndDown
            ? _c("v-fade-transition", [
                _vm.icon && !_vm.isTimeout
                  ? _c(
                      "div",
                      [
                        _vm.loading
                          ? _c("v-progress-circular", {
                              attrs: {
                                size: "16",
                                width: "2",
                                indeterminate: "",
                              },
                            })
                          : _c("v-img", {
                              attrs: {
                                src: _vm.icon,
                                height: "16",
                                eager: "",
                                contain: "",
                              },
                            }),
                      ],
                      1
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
          _c("v-select", {
            attrs: {
              value: _vm.value,
              items: _vm.items,
              "item-value": _vm.itemValue,
              "item-text": _vm.itemText,
              placeholder: _vm.placeholder,
              attach: _vm.attach,
              "menu-props": _vm.menuProps,
              "hide-details": "",
              dense: "",
              outlined: "",
              "single-line": "",
            },
            on: {
              input: function ($event) {
                return _vm.$emit("input", $event)
              },
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }